import { Component } from '@verndale/core';
import { open, close } from '../helpers';

class Module extends Component {
  setupDefaults() {
    this.dom = {
      options: this.el.querySelectorAll('.language-selector__item'),
      trigger: this.el.querySelector('.language-selector__list-container'),
      list: this.el.querySelector('.language-selector__list'),
      selectedValue: this.el.querySelector(
        '.language-selector__selected-value'
      ),
      icon: this.el.querySelector('.language-selector__chevron-icon')
    };
  }

  addListeners() {
    this.dom.trigger.addEventListener('click', this.handleDropdown.bind(this));
    this.dom.list.addEventListener('mouseleave', this.handleOutside.bind(this));
  }

  handleDropdown() {
    if (this.dom.selectedValue.hasAttribute('aria-expanded')) {
      this.dom.selectedValue.removeAttribute('aria-expanded');
      this.dom.icon.classList.remove('language-selector__chevron-icon--open');
      close({ element: this.dom.list });
    } else {
      this.dom.selectedValue.setAttribute('aria-expanded', 'true');
      this.dom.icon.classList.add('language-selector__chevron-icon--open');
      open({ element: this.dom.list });
    }
  }

  handleOutside(e) {
    this.dom.selectedValue.removeAttribute('aria-expanded');
    this.dom.icon.classList.remove('language-selector__chevron-icon--open');
    close({ element: this.dom.list });
    e.stopPropagation();
  }
}

export default Module;
